var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 511.338,
    cy: 514.97,
    gradientTransform: "matrix(1 0 0 1 0 0)",
    gradientUnits: "userSpaceOnUse",
    id: "RadialGradient",
    r: 478.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64876,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363535"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 514.636,
    cy: 511.77,
    gradientTransform: "matrix(1 0 0 1 0 0)",
    gradientUnits: "userSpaceOnUse",
    id: "RadialGradient_2",
    r: 374.945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661157,
    stopColor: "#c65555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554b4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.921282 0 0 1.01446 -15.6412 -1.78133)",
    gradientUnits: "userSpaceOnUse",
    id: "LinearGradient",
    x1: 490.05,
    x2: 799.41,
    y1: 422.612,
    y2: 422.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d06262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931818,
    stopColor: "#f4f4f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3661 514.97C32.3661 254.36 246.809 43.0944 511.338 43.0944C775.867 43.0944 990.309 254.36 990.309 514.97C990.309 775.58 775.867 986.846 511.338 986.846C246.809 986.846 32.3661 775.58 32.3661 514.97Z",
    fill: "url(#RadialGradient)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#373434",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.691 511.77C139.691 305.833 307.56 138.889 514.636 138.889C721.712 138.889 889.581 305.833 889.581 511.77C889.581 717.706 721.712 884.65 514.636 884.65C307.56 884.65 139.691 717.706 139.691 511.77Z",
    fill: "url(#RadialGradient_2)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#373434",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.262 285.786C456.262 285.786 513.369 304.914 568.693 326.864C626.685 349.873 626.327 355.064 648.142 423.951C670.179 493.54 700.736 590.907 700.736 590.907C695.199 546.937 701.142 498.314 701.344 452.018C701.547 405.722 696.01 361.752 667.512 327.089C642.67 296.872 604.057 287.139 562.001 282.526C519.945 277.914 474.446 278.422 435.833 268.689",
    fill: "url(#LinearGradient)",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.757a7728bc7a6df6de796cc4b5631fe9.svg";
export { ForwardRef as ReactComponent };